export default async function channelLiteRedirect ({ to, store }) {
  const authToken = store.state.authToken || await store.dispatch('loadAuthToken', null, { root: true })

  if (!authToken) return { path: '/' }
  let user = store.getters['users/me']

  // wait for user load
  if (!user) {
    await store.dispatch('users/getSelf', authToken)
    user = store.getters['users/me']
  }
  const school = user && user.school
  const hasChannels = school && Number(school.properties.channels)

  if (hasChannels || to.name === 'lite-channels') return

  return { name: 'lite-channels' }
}
